export enum ButtonTypesEnum {
  AVAILABLE_SOON = 'AVAILABLE_SOON',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  ADD_TO_CART_BUNDLE = 'ADD_TO_CART_BUNDLE',
  ADD_TO_CART_WITH_SUBSCRIBE = 'ADD_TO_CART_WITH_SUBSCRIBE',
  ADD_TO_CART = 'ADD_TO_CART',
  SUBSCRIBE = 'SUBSCRIBE',
  NYA_PRODUCT = 'NYA_PRODUCT',
}
